const SemVerGte = require('semver/functions/gte')
angular
  .module('surfsightApp.controllers')

  .controller('EdgeRecordingsTimelineControllerDeprecated', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'leafletData',
    'nominatimLookUp',
    'SystemConstants',
    'UnitSystem',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      leafletData,
      nominatimLookUp,
      SystemConstants,
      UnitSystem
    ) {
      const $translate = $filter('translate')
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $mdSidenav('recordings-timeline-container').open()
      }
      const deviceId = parseInt($stateParams.deviceId)
      $scope.timelineInfo = {
        checking: false,
        showTimeline: false,
        deviceId
      }
      const getOnlineStatus = async serialNumber => {
        const requestJson = {
          method: 'POST',
          url: `${EDGE_BASEURL}/rpc-devices-tunnel-status`,
          data: {
            serialNumbers: [serialNumber]
          },
          headers: {
            'x-hide-original-mqtt-device-state': false
          }
        }
        const response = await $http(requestJson)
        return response.data.devices[0].status === 'online'
      }
      const initRecordingTimeline = async () => {
        const serialNumber = $scope.edge.uri
        $scope.timelineInfo.checking = true
        $scope.timelineInfo.showTimeline = false
        const [onlineStatus, deviceSemanticVersion] = await Promise.all([
          getOnlineStatus(serialNumber),
          $rootScope.getDeviceSematicVersion(serialNumber)
        ])
        if (onlineStatus) {
          const canPlayTimeline = SemVerGte(
            deviceSemanticVersion,
            window.CAN_PLAY_RECORDING_STREAM_VERSION
          )
          $scope.timelineInfo.checking = false
          if (canPlayTimeline) {
            $scope.timelineInfo.showTimeline = true
          } else {
            $state.go('home.common.recordings.list', { edge_id: deviceId })
          }
        } else {
          showMessageToast(
            $translate('recordingsAreNotAvailableAsTheCameraIsOffline')
          )
        }
        $scope.$apply()
      }
      const showMessageToast = message => {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .hideDelay(5000)
        $mdToast
          .show(toast)
          .then(() => {})
          .catch(() => {})
      }
      if (deviceId) {
        let edge = edgeFactory.list.find(e => e.id === deviceId)
        $scope.edge = edge
        if ($scope.edge) {
          initRecordingTimeline()
        } else {
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', { id: deviceId })
          const canceller = $scope.$on(
            'LOAD_DEVICE_DETAILS_SUCCESS',
            async (_, data) => {
              if (data.id === deviceId) {
                canceller()
                edge = edgeFactory.list.find(e => e.id === deviceId)
                $scope.edge = edge
                initRecordingTimeline()
              }
            }
          )
        }
      } else {
        $state.go('home.common.recordings')
      }
    }
  ])
